import React from 'react';
import GridConditionCustomize from './GridConditionCustomize';
import GridConditionOptions from './GridConditionOptions';
import SearchConditionOptionsForm from './SearchConditionOptionsForm';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { getConditionOptions, setSearchParams } from '../../../redux/slices/condition';
import { BUSINESS_TYPE, CONDITION_VIEW_MODES, MANAGE_CONDITION_TYPES, STEEL_MAKER } from '../../../constants';
import type { ConditionOptionsSearchInput, ConditionOptionsSearchParams } from '../../../types/condition';

const GridConditionOrdinary = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { isLoading, selectedTab, selectedViewMode, selectedSteelMaker, selectedBusinessType, selectedSteelCategory, condition, conditionOptions, searchParams } = useSelector(
    (state: RootState) => state.condition,
  );
  const isDomesticAichi: boolean = selectedBusinessType === BUSINESS_TYPE.DOMESTIC && selectedSteelMaker === STEEL_MAKER.AICHISTEEL;
  const isDomesticKobe: boolean = selectedBusinessType === BUSINESS_TYPE.DOMESTIC && selectedSteelMaker === STEEL_MAKER.KOBESTEEL;
  const isExportAichi: boolean = selectedBusinessType === BUSINESS_TYPE.EXPORT && selectedSteelMaker === STEEL_MAKER.AICHISTEEL;
  const isExportKobe: boolean = selectedBusinessType === BUSINESS_TYPE.EXPORT && selectedSteelMaker === STEEL_MAKER.KOBESTEEL;
  const isExportNsc: boolean = selectedBusinessType === BUSINESS_TYPE.EXPORT && selectedSteelMaker === STEEL_MAKER.NIPPONSTEEL;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // React.useEffect(() => {
  //   console.log(searchParams);
  // }, [searchParams]);

  // EVENT HANDLER
  // ================================================================================

  // 検索パラメータを変更する
  // ただし空文字列だったら検索パラメータから削除する
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const field = event.target.id as keyof ConditionOptionsSearchInput;
    const value: string = event.target.value;
    if (value === '') {
      // https://chaika.hatenablog.com/entry/2020/05/13/083000
      const omitProperty = (obj: ConditionOptionsSearchParams) => (key: keyof ConditionOptionsSearchInput) => {
        return (({ [key]: value, ...newObjct }) => newObjct)(obj);
      };
      const omittedParams: ConditionOptionsSearchParams = omitProperty(searchParams)(field);
      // console.log(omittedParams);
      dispatch(setSearchParams(omittedParams));
    } else {
      const updateParams: ConditionOptionsSearchParams = Object.assign({}, searchParams, { [event.target.id]: event.target.value });
      // console.log(updateParams);
      dispatch(setSearchParams(updateParams));
    }
  };

  // 検索する
  const handleSearch = (): void => {
    dispatch(getConditionOptions(searchParams));
  };

  // VIEW
  // ================================================================================

  return (
    <>
      {selectedTab === MANAGE_CONDITION_TYPES.CUSTOMIZE && (
        <GridConditionCustomize isLoading={isLoading} viewMode={selectedViewMode} steelMaker={selectedSteelMaker} businessType={selectedBusinessType} condition={condition} />
      )}
      {selectedTab === MANAGE_CONDITION_TYPES.CUSTOMIZE && selectedViewMode === CONDITION_VIEW_MODES.EDITING && (
        <>
          <SearchConditionOptionsForm
            isLoading={isLoading}
            searchParams={searchParams}
            isDisabledCustomer1={false}
            isDisabledCustomer2={isDomesticAichi || isDomesticKobe || isExportAichi || isExportKobe}
            isDisabledCustomer3={isDomesticAichi || isDomesticKobe || isExportAichi || isExportKobe || isExportNsc}
            isDisabledDeliveryLocation={isDomesticKobe || isExportAichi || isExportKobe || isExportNsc}
            isDisabledStandard={false}
            isDisabledSizeDiameter={false}
            onChange={handleChange}
            onSearch={handleSearch}
          />
          <GridConditionOptions
            isLoading={isLoading}
            steelMaker={selectedSteelMaker}
            businessType={selectedBusinessType}
            steelCategory={selectedSteelCategory}
            condition={condition}
            conditionOptions={conditionOptions}
            searchParams={searchParams}
          />
        </>
      )}
    </>
  );
};

export default GridConditionOrdinary;
